import {
  toggleCollapse,
  dialogHide,
  loadingStop,
  resetStop,
  LOGIN_MODEL,
  IS_FUZZY_VERIFY,
  SET_MCA_SWITCH,
  SET_PRINT_TYPE,
  COLLAPSE_ALL_SIDE,
  setCollapse,
  SET_PERSONALIZED_SELECT_RANGE_CACHE
} from './type'

const state = {
  isCollapse: true,
  dialogBoxVisible: false,
  isLoading: false,
  loginModel: false,
  isFuzzyVerify: true,
  mcaSwitch: false,
  printType: Number(localStorage.getItem('printType')) || '1',
  isCollapseAllSide: false,
  personalizedSelectRangeCache: null // 个性化选择范围字典缓存
}

const mutations = {
  [toggleCollapse] (state) {
    state.isCollapse = !state.isCollapse
  },
  [dialogHide] (state) {
    state.dialogBoxVisible = !state.dialogBoxVisible
  },
  [loadingStop] (state) {
    state.isLoading = !state.isLoading
  },
  [resetStop] (state) {
    state.isLoading = false
    state.dialogBoxVisible = false
  },
  [LOGIN_MODEL] (state, value) {
    state.loginModel = value
  },
  [IS_FUZZY_VERIFY] (state, value) {
    state.isFuzzyVerify = value
  },
  [SET_MCA_SWITCH] (state, value) {
    state.mcaSwitch = value
  },
  [SET_PRINT_TYPE] (state, value) {
    state.printType = value
    localStorage.setItem('printType', value)
  },
  [COLLAPSE_ALL_SIDE] (state,value) {
    state.isCollapseAllSide = value
  },

  [setCollapse] (state,value) {
    state.isCollapse = value
  },
  [SET_PERSONALIZED_SELECT_RANGE_CACHE] (state, value) {
    state.personalizedSelectRangeCache = value
  },
}

const getters = {
  isCollapse (state) {
    return state.isCollapse
  },
  dialogBoxVisible (state) {
    return state.dialogBoxVisible
  },
  // 当前Vue loading绑定用，ajax error时会调用翻转
  isLoading (state) {
    return state.isLoading
  },
  loginModelStatus (state) {
    return state.loginModel
  },
  fuzzyVerifyStatus (state) {
    return state.isFuzzyVerify
  },
  mcaSwitchStatus (state) {
    return state.mcaSwitch
  },
  printType (state) {
    return state.printType
  },
  isCollapseAllSide (state) {
    return state.isCollapseAllSide
  },
  personalizedSelectRangeCache (state) {
    return state.personalizedSelectRangeCache
  }
}

export default {
  state,
  mutations,
  getters
}
